import env from '@trashlab/sitesapp/src/env';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';
import { TenantProvider } from '@trashlab/sitesapp/src/contexts/tenant-provider';
import { ErrorComponent } from '@trashlab/sitesapp/src/components/error';
import { NotFoundComponent } from '@trashlab/sitesapp/src/components/not-found';
import { ThemeProvider } from 'next-themes';
import { OrgTemplateSelector } from '@trashlab/sitesapp/src/organizations/org-template-selector';
import { AnalyticsTracker } from '@trashlab/sitesapp/src/components/analytics/analytics-tracker';
import { GoogleAnalytics } from '@trashlab/sitesapp/src/components/analytics/google-analytics';
import { ChatWidget } from '@trashlab/sitesapp/src/components/chat-widget';
import { EditOverlay } from '@trashlab/sitesapp/src/components/edit-mode/edit-overlay';
import { lazy, Suspense } from 'react';

const DevWebsiteSwitcher = lazy(() =>
  import('@trashlab/sitesapp/src/components/dev/dev-website-switcher').then(
    (m) => ({ default: m.DevWebsiteSwitcher }),
  ),
);

export const rootRoute = createRootRouteWithContext()({
  notFoundComponent: NotFoundComponent,
  errorComponent: ErrorComponent,
  beforeLoad: () => {
    window.scrollTo(0, 0);
  },
  component: () => {
    return (
      <>
        {!env.isProd && (
          <Suspense>
            <DevWebsiteSwitcher />
          </Suspense>
        )}
        <TenantProvider>
          <ThemeProvider
            attribute="class"
            defaultTheme="light"
            forcedTheme="light"
          >
            {!env.isProd && <TanStackRouterDevtools />}
            <AnalyticsTracker />
            <GoogleAnalytics />
            <ChatWidget />
            <EditOverlay />
            <OrgTemplateSelector>
              <Outlet />
            </OrgTemplateSelector>
          </ThemeProvider>
        </TenantProvider>
      </>
    );
  },
});
